import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import UserActions from "../../store/actions/userActions";

export function useOidcEvents(userManager) {
  const dispatch = useDispatch();

  const redirectUponTokenExpiration = useCallback(() => {
    userManager.signinRedirect();
  }, [ userManager ]);

  const updateStoreOnUserUpdate = useCallback((user) => {
    dispatch(UserActions.setLoggedIn({
      details: user
    }));
  }, [ dispatch ]);

  const addOidcEvents = useCallback(() => {
    userManager.events.addAccessTokenExpired(redirectUponTokenExpiration);
    userManager.events.addUserLoaded(updateStoreOnUserUpdate);
  }, [ redirectUponTokenExpiration, updateStoreOnUserUpdate, userManager ]);

  const removeOidcEvents = useCallback(() => {
    userManager.events.removeAccessTokenExpired(redirectUponTokenExpiration);
    userManager.events.removeUserLoaded(updateStoreOnUserUpdate);
  }, [ redirectUponTokenExpiration, updateStoreOnUserUpdate, userManager ]);

  useEffect(() => {
    addOidcEvents();

    return removeOidcEvents;
  }, [ userManager, addOidcEvents, removeOidcEvents]);
}